import request from "../request";

/**
 * 获取我的信息
 */
export const getUserMe = async (): Promise<API.USER.Me> => {
  return await request.get(`/workbenchApi/me`);
};
